import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {MemberLoyaltySignupReportData} from "./member-loyalty-signup-report.data";

@Injectable()
export class MemberLoyaltySignupReportModel extends ReportModel<MemberLoyaltySignupReportData> {
    constructor(injector: Injector) {
        super(injector, MemberLoyaltySignupReportData);
    }
}
